<template>
    <div class="select_block">
        <b-modal ref="profile_modal"
                 v-if="is_show_modal"
                 size="xl"
                 bodyClass="p-0"
                 v-bind:no-close-on-backdrop=false
                 :hide-header=true
                 v-model="is_show_modal"
                 :dialogClass=dialog_class_draw>

            <!-- BODY -->
            <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
                <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                    <h2>
					<span class="fw-300">
                        {{ __t('SELECT_PRODUCT') }}
					</span>
                    </h2>
                    <div class="panel-toolbar pr-3 pb-2 align-self-end">
                        <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed"
                                v-on:click="close()">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                </div>

                <div class="panel-container show p-4">

                    <organization_filter></organization_filter>

                    <div class="form-group_up">
                        <label class="form-label" for="name-f">
                            {{ __t('SEARCH') }}
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                            <span class="input-group-text  border-right-0">
                                <i class="fal fa-democrat"></i>
                            </span>
                            </div>

                            <input type="text" v-model="search_param" id="filter_search" class="form-control"
                                   :placeholder="__t('SEARCH')">

                            <div class="input-group-append srch">
                                <button class="btn btn-primary shadow-0 waves-effect waves-themed" v-on:click="send_search">
                                    <i class="fal fa-search"></i>
                                </button>
                                <button type="button" class="btn btn-danger shadow-0  waves-effect waves-themed"
                                        v-on:click="clean_inbox_filter">
                                    <span class="fal fa-times mr-1"></span>
                                    {{ __t("CLEAN_FILTER") }}
                                </button>
                            </div>
                        </div>
                        <span class="help-block">
                {{ __t('SEARCH_HELPER') }}
                </span>
                    </div>

                    <div class="add_list pt-2 pb-2" v-if="is_multiple">
                        <button class="btn btn-md btn-block btn-outline-success waves-effect waves-themed"
                                v-on:click="push_products()">
                            <span class="fal  fa-eject mr-1"></span>
                            {{ __t('SELECT_PRODUCT') }}
                        </button>
                    </div>


                    <b-skeleton-table v-if="is_load" :rows=this.cur_records :columns="2" :hide-header=true
                                      :table-props="{ bordered: false, striped: true }"></b-skeleton-table>

                    <div class="inbox_vue_list" v-if="!is_load && rows.length > 0">
                        <div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <sys_pagination trigger_change="modal_pagi" key="up_modal"></sys_pagination>
                        </div>


                        <b-table
                            v-if="rows.length > 0"

                            striped class="table-responsive-xl resolution_table" :items="rows" :fields="fields">

                            <template v-slot:table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Працюэмо...</strong>
                                </div>
                            </template>

                            <!-- header fields -->
                            <template v-slot:head(id)="data">
                                <div class="custom-control custom-checkbox">
                                    <input
                                        :disabled="is_multiple"
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="imc_checker_all"/>
                                    <label class="custom-control-label cursor-pointer bolder" for="imc_checker_all"></label>
                                </div>
                            </template>

                            <template v-slot:head(filename)="data">
                                <div class="fs-xl text-left" v-html="data.label"></div>
                            </template>

                            <template v-slot:head(ordering)="data">
                                <grid list_ordering="ordering" :is_html=true :field_name="data.label"></grid>
                            </template>


                            <template v-slot:head(title)="data">
                                <grid list_ordering="title" :field_name="__t('TITLE')"></grid>
                            </template>

                            <template v-slot:head(price)="data">
                                <grid list_ordering="price" :field_name="__t('PRICE')"></grid>
                            </template>

                            <template v-slot:head(uniq_id)="data">
                                <div class="fs-xl text-center" v-html="data.label"></div>
                            </template>

                            <!-- body draw -->
                            <template v-slot:cell(id)="data">
                                <div class="custom-control custom-checkbox">
                                    <input
                                        :name="'cid[]'"
                                        :checked="is_checked_item(data.item)"
                                        v-on:click="push_in_select(data.item)"
                                        type="checkbox"
                                        class="custom-control-input"
                                        :id="data.item.id + '_cust_id'"/>

                                    <label class="custom-control-label cursor-pointer bolder"
                                           :for="data.item.id + '_cust_id'"></label>
                                </div>
                            </template>

                            <template v-slot:cell(filename)="data">
                                <div class="img_block  rounded" style="max-width: 100px">
                                    <picture>
                                        <source :srcset="data.item.main_photo.webp" type="image/webp">
                                        <source :srcset="data.item.main_photo.jpeg" type="image/jpeg">
                                        <img style="max-width: 90px" itemprop="image" :src="data.item.main_photo.jpeg">
                                    </picture>
                                </div>
                            </template>

                            <template v-slot:cell(title)="data">
                                <div class="prod_name  fs-xl color-success-600">
                                    <span v-html=nice_search(data.item.title)></span>
                                    <span class="small text-info pl-2">
									<i class="fal fa-lock" v-if="data.item.skeep_sync"></i>
								</span>

                                </div>
                                <div class="categ_name">
                                    <div class="small badge border border-primary text-primary" v-if="data.item.main_categ">
                                        {{ data.item.main_categ.title }}
                                    </div>
                                </div>

                                <div class="mt-1" v-if="data.item.hasOwnProperty('visible_providers')">
                                    <div class="small badge border border-info  text-info mr-1"
                                         v-for="prov in data.item.visible_providers"
                                         v-if="prov.is_on"
                                    >
                                        {{ prov.human_name }}
                                    </div>

                                    <div class="small badge border border-warning text-black-50  mr-1">
                                        {{ data.item.prov_name }}
                                    </div>
                                </div>

                                <div class="art" v-if="data.item.product_code">
                                    Code : <span v-html=nice_search(data.item.product_code)></span>
                                </div>

                            </template>

                            <template v-slot:cell(price)="data">
                                <div class="prod_price bold color-primary-900 mt-1">
                                    {{ new Intl.NumberFormat('ru-RU').format(parseFloat(data.item.price)) }}
                                    <span class="woocommerce-Price-currencySymbol  fs-sm"> ₴</span>
                                </div>

                                <div class="prod_price fs-xs  color-info-900 mt-1" v-if="data.item.price_weight > 0">
                                    {{ new Intl.NumberFormat('ru-RU').format(parseFloat(data.item.price_weight)) }}
                                    <span class="woocommerce-Price-currencySymbol  fs-sm"> ₴</span>
                                </div>

                            </template>

                            <template v-slot:cell(uniq_id)="data">
                                <div class="text-center mt-4">
                                    <i class="text-center fal fa-plus width-2 cursor-pointer fs-xxl color-primary-900"
                                       v-on:click="choice_active_prod(data.item)">

                                    </i>
                                </div>
                            </template>
                        </b-table>


                        <div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <sys_pagination trigger_change="modal_pagi" key="down_modal"></sys_pagination>
                        </div>
                    </div>
                </div>
                <!--FOOTER -->


            </div>

            <template v-slot:modal-footer="{close}">
                <div class="modal-footer">

                    <div class="add_list pt-2 pb-2" v-if="is_multiple">
                        <button class="btn btn-md btn-block btn-outline-success waves-effect waves-themed"
                                v-on:click="push_products()">
                            <span class="fal  fa-eject mr-1"></span>
                            {{ __t('SELECT_PRODUCT') }}
                        </button>
                    </div>

                    <button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
                        {{ __t('CLOSE') }}
                    </button>
                </div>
            </template>


        </b-modal>
    </div>
</template>

<script>

import {createHelpers} from 'vuex-map-fields';
import Sys_pagination from "../../../../sys/pagination/pagination";
import grid from "../../../../sys/grid/grid";
import organization_filter from "../../organizations/organization_filter";

const {mapFields} = createHelpers({
    getterType: 'inbox_state/getInboxStateField',
    mutationType: 'inbox_state/updateInboxStateField',
});
import {mapGetters} from "vuex";
let uuid = 0;

export default {
    name: "product_modal_list",
    components: {Sys_pagination, grid,organization_filter},
    props: {
        modal_position: {
            type: String,
            default: "center"
        },
        show_trigger: {
            type: String,
            default: "select_product_modal"
        },

        push_trigger_list : {
            type : String,
            default : "select_product_list_modal"
        },
        uuid: {
            type: String,
            default: function () {
                return this.$options.name + '-' + uuid++;
            },
        },
        push_trigger: {
            type: String,
            default: "selected_prod",
        },
        selected_ids: {
            type: Array,
            default() {
                return []
            }
        },
        is_multiple: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {

            //  show_trigger : "",
            is_show_modal: false,
            rows: [],
            search_txt: "",
            cur_records: 20,
            is_load: false,
            work_ids: [],
            fields: [
                {
                    key: 'id',
                    label: '',
                    class: 'text-center'
                },
                {
                    key: 'filename',
                    label: '<i class="fas fa-photo-video"></i>',
                    class: 'text-center'
                },
                {
                    key: 'title',
                    label: 'p.title',
                    class: ''
                },

                {
                    key: 'price',
                    label: 'p.price',
                    class: ''
                },
                {
                    key: 'uniq_id',
                    label: '<i class="fal fa-cog width-2"></i>',
                    class: ''
                },
            ],
        }
    },
    created() {
        EventBus.$on(this.show_trigger, this.work_click);
        EventBus.$on("products_reload_items", this.load_products);
        EventBus.$on("modal_pagi", this.change_state);
        EventBus.$on('choose_org_id',this.filter_select)

        this.cur_instanse = '';
    },

    beforeDestroy() {
        EventBus.$off(this.show_trigger, this.work_click);
        EventBus.$off("products_reload_items", this.load_products);
        EventBus.$off("modal_pagi", this.change_state);
        EventBus.$off('choose_org_id',this.filter_select)

        this.cur_instanse = '';
    },

    mounted() {

    },

    methods: {
        async push_products() {

            if(this.work_ids.length > 0) {
                this.is_load = true;
                //Fetch Products
                await api.post('/internal/catalog/products', {
                    'product_ids': this.work_ids
                })
                    .then(({data}) => {
                        this.is_load = false;
                        if (data.status === "operation_success") {
                            EventBus.$emit(this.push_trigger_list, data.data);
                            this.work_ids = [];
                            this.close();
                        }
                        else {
                            console.error("PRODS_NOT_FOUND");
                        }
                    })
                    .catch(({response}) => {
                        this.is_load = false;
                        EventBus.$emit('show_toast', {
                            err: response.data.message,
                            type: "danger",
                            title: response.data.status
                        })
                    });
            }
            else {
                EventBus.$emit(this.push_trigger_list, []);
                this.close();
            }
        },

        is_checked_item(prod) {

            let prod_id = parseInt(prod.id);
            let _in = this.work_ids.filter(id => {
                return parseInt(id) == prod_id;
            });
            return _in.length > 0;
        },
        push_in_select(prod) {
            this.work_select(prod);
        },

        choice_active_prod(prod) {
            this.work_select(prod);
        },

        work_select(prod) {
            if (this.is_multiple) {
                let is_find = false;
                let tmp = this.work_ids;//JSON.parse(JSON.stringify(this.selected_ids));
                //https://gist.github.com/chad3814/2924672
                for (let i = tmp.length - 1; i >= 0; i -= 1) {
                    if (tmp[i] === prod.id) {
                        tmp.splice(i, 1);
                        is_find = true;
                    }
                }

                if (is_find === false) {
                    tmp.push(parseInt(prod.id));
                }
            } else {
                EventBus.$emit(this.push_trigger, prod);
                this.close();
            }
        },

        filter_select(res) {
            console.log("Filter_DATA",res);
            this.send_list.limit_start = 0;
            this.filter[res.type] = res.value;

            this.change_state({
                type: "filter_select"
            });
        },


        send_search() {
            this.send_list.limit_start = 0;
            this.send_list.start = 0;
            this.filter.search = this.search_txt;

            console.log(this.send_list);

            this.change_state({
                type: "search_called"
            });
        },

        nice_search(str) {
            if (!this.filter.hasOwnProperty('search')) {
                return str;
            }
            return str.replace(new RegExp(this.filter.search, "gi"), match => {
                return '<span class="text-danger">' + match + '</span>';
            });
        },

        close_modal() {
            this.close()
        },
        close() {
            this.is_show_modal = false;
        },

        work_click() {
            this.clean_start_state();
            this.work_ids = [];
            if (this.is_multiple) {

                if (this.selected_ids.length > 0) {
                    this.selected_ids.map(id => {
                        this.work_ids.push(id);
                    });
                }
            }
        },

        clean_inbox_filter() {

            this.send_list.limit_start = 0;
            this.filter.search = "";

            this.send_list.direction = "DESC";
            this.send_list.ordering = "ordering";

            let self = this;
            Object.keys(this.all_filter).map(name => {
                self.filter[name] = "";
            });

            this.change_state({
                type: "search_called",
                force_reload: false,
            });

        },
        async change_state(state_field) {
            this.is_load = false;
            if (myapp_config.debugState) {
                console.log("%c|___LIST change State...", "color: #fd3995", state_field);
            }

            let send = {
                filter: this.filter,
                list: this.send_list
            };
            this.__l(send, "info", "State Send -> Reolad");
            let self = this;
            await api.post("/internal/catalog/products/filter", qs.stringify(send)).then(({data}) => {
                if (data.status === "operation_success") {
                    let res = data.message;
                    if (res.hasOwnProperty("arr_state")) {
                        res.arr_state.uiid = this.uuid;
                        this.$store.dispatch('inbox_state/LOAD_STATES', res.arr_state);
                    }
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        async clean_start_state() {
            this.is_load = true;
            let self = this;
            await api.post('/internal/catalog/products/state_info').then(({data}) => {
                if (data.status === "operation_success") {
                    let resp = data.message;
                    this.is_show_modal = true;
                    if (resp.hasOwnProperty("arr_state")) {
                        resp.arr_state.uiid = this.uuid;
                        this.$store.dispatch('inbox_state/LOAD_STATES', resp.arr_state);
                        setTimeout(() => {
                            self.clean_inbox_filter();
                        }, 1000);
                    }
                }
            }).catch(({response}) => {
                this.is_load = false;
                this.is_show_modal = true;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },

        async load_products(state) {
            console.log("uiid :"+ this.uuid,state.uiid);
            if(this.uuid != state.uiid) {
                console.log("another uiid :"+ this.uuid,state.uiid);
                return ;
            }

            this.rows = [];
            this.is_load = true;
            await api.post('/internal/catalog/products')
                .then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.rows = data.data;
                        this.$store.dispatch('inbox_state/LOAD_PAGINATION', data.message.pagination);
                    } else {
                        this.rows = [];
                    }
                })
                .catch(({response}) => {
                    this.is_load = false;
                    this.rows = [];
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status
                    })
                });
        },

        async save_settings() {

        },
    },

    computed: {
        ...mapFields([
            'list',
            'filter',
            'doc_type',
            'send_list',
            'all_filter'
        ]),
        dialog_class_draw() {
            if (this.modal_position === "left") {
                return "modal-dialog-left modal-sm";
            }

            return "modal-dialog-left modal-xl";
        },

        selected_products: {
            get: function () {

            },
            set: function (newValue) {

            }
        },

        search_param: {
            get: function () {
                if (this.all_filter.hasOwnProperty('search')) {
                    if (this.all_filter.search == null) {
                        return "";
                    }
                    return this.all_filter.search;
                }
                return "";
            },
            set: function (newValue) {
                this.search_txt = newValue;
            }
        },

    }
}
</script>

<style scoped>
.prod_price {
    font-size: 20px;
}
</style>
